var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.showDialog,
      "no-click-animation": "",
      "persistent": "",
      "width": "500",
      "transition": false
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t("globals.newVersionTitle")))]), _c('v-card-text', [_vm._v(_vm._s(_vm.$t("globals.newVersionText")))]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("globals.reloadButton")) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }